import logo from "../argocd/logo.svg";
import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";

export const argoWorkflows = defineConnector({
  identifier: "argoWorkflows",
  name: "Argo Workflows",
  tagLine: "Kubernetes-native workflow engine",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: ({ serverUrl }) => urlToPattern(serverUrl),
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Create or copy an Argo API token",
      items: [
        {
          kind: "markdown",
          content:
            "Create or copy a bearer token that can call your Argo Server API. The Argo docs show using `Authorization: Bearer <token>` against the `/api/v1/userinfo` endpoint.",
        },
      ],
    },
    {
      title: "Enter your Argo Workflows details",
      items: [
        {
          kind: "url",
          label: "Argo Server URL",
          required: true,
          placeholder: "https://argo.example.com",
          target: { kind: "configuration", field: "serverUrl" },
          helperText: "The base URL for your Argo Server.",
        },
        {
          kind: "input",
          label: "Bearer token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ serverUrl }) =>
      `${serverUrl || "https://argo.example.com"}/api/v1/userinfo`,
  },
});
